import axios from 'axios'
import { ref, reactive, computed } from 'vue'
import { useAuth0 } from '@auth0/auth0-vue'

// Global
const accessToken = ref('')

// Headers
const servicesHeaders = computed(() => {
  return {
    'x-token': accessToken.value
  }
})
const uploadHeaders = computed(() => {
  return {}
})
const fastlyHeaders = computed(() => {
  return {}
})
const wowzaHeaders = computed(() => {
  return {}
})
const billingHeaders = computed(async () => {
  console.log('in headers!', useAuth0())
  const { getAccessTokenSilently } = useAuth0()
  const billingAccessToken = await getAccessTokenSilently()
  console.log('token: ', billingAccessToken)
  return {
    Authorization: `Bearer ${billingAccessToken}`
  }
})

// Environment URLs
const servicesUrl = process.env.VUE_APP_SERVICE_API_URL
const uploadUrl = process.env.VUE_APP_UPLOAD_BASE_URL
const fastlyUrl = process.env.VUE_APP_FASTLY_API_URL
const wowzaUrl = process.env.VUE_APP_WOWZA_API_URL
const billingUrl = process.env.VUE_APP_BILLING_API_URL

// Axios
const axiosGet = ({ base, headers, endpoint, params = null }) => {
  return new Promise((resolve, reject) => {
    let url = `${base}${endpoint}`
    if (params) {
      url += `?${new URLSearchParams(params).toString()}`
    }
    axios.get(url, { headers }).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const axiosPost = ({ base, headers, endpoint, params }) => {
  return new Promise((resolve, reject) => {
    const url = `${base}${endpoint}`
    axios.post(url, params, { headers }).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const axiosPut = ({ base, headers, endpoint, params }) => {
  return new Promise((resolve, reject) => {
    const url = `${base}${endpoint}`
    axios.put(url, params, { headers }).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

// Sherpa Services
const servicesGet = ({ endpoint, params }) => {
  return axiosGet({
    base: servicesUrl,
    headers: servicesHeaders.value,
    endpoint,
    params
  })
}

const servicesPost = ({ endpoint, params }) => {
  return axiosPost({
    base: servicesUrl,
    headers: servicesHeaders.value,
    endpoint,
    params
  })
}

const servicesPut = ({ endpoint, params }) => {
  return axiosPut({
    base: servicesUrl,
    headers: servicesHeaders.value,
    endpoint,
    params
  })
}

// Fastly
const fastlyGet = ({ endpoint, params }) => {
  return axiosGet({
    base: fastlyUrl,
    headers: fastlyHeaders.value,
    endpoint,
    params
  })
}

const fastlyPost = ({ endpoint, params }) => {
  return axiosPost({
    base: fastlyUrl,
    headers: fastlyHeaders.value,
    endpoint,
    params
  })
}

const fastlyPut = ({ endpoint, params }) => {
  return axiosPut({
    base: fastlyUrl,
    headers: fastlyHeaders.value,
    endpoint,
    params
  })
}

// Wowza
const wowzaGet = ({ endpoint, params }) => {
  return axiosGet({
    base: wowzaUrl,
    headers: wowzaHeaders.value,
    endpoint,
    params
  })
}

const wowzaPost = ({ endpoint, params }) => {
  return axiosPost({
    base: wowzaUrl,
    headers: wowzaHeaders.value,
    endpoint,
    params
  })
}

const wowzaPut = ({ endpoint, params }) => {
  return axiosPut({
    base: wowzaUrl,
    headers: wowzaHeaders.value,
    endpoint,
    params
  })
}

// S3 File Upload
const uploadGet = ({ endpoint, params }) => {
  return axiosGet({
    base: uploadUrl,
    headers: uploadHeaders.value,
    endpoint,
    params
  })
}

const uploadPost = ({ endpoint, params }) => {
  return axiosPost({
    base: uploadUrl,
    headers: uploadHeaders.value,
    endpoint,
    params
  })
}

const uploadPut = ({ endpoint, params }) => {
  return axiosPut({
    base: uploadUrl,
    headers: uploadHeaders.value,
    endpoint,
    params
  })
}

// Billing Hub
const billingGet = async ({ endpoint, params }) => {
  return axiosGet({
    base: billingUrl,
    headers: await billingHeaders.value,
    endpoint,
    params
  })
}

const billingPost = async ({ endpoint, params }) => {
  return axiosPost({
    base: billingUrl,
    headers: await billingHeaders.value,
    endpoint,
    params
  })
}

const billingPut = async ({ endpoint, params }) => {
  return axiosPut({
    base: billingUrl,
    headers: await billingHeaders.value,
    endpoint,
    params
  })
}

// Composable Object
const useApi = reactive({
  services: {
    v1: {
      get: servicesGet,
      post: servicesPost,
      put: servicesPut
    }
  },
  billing: {
    get: billingGet,
    post: billingPost,
    put: billingPut
  },
  upload: {
    get: uploadGet,
    post: uploadPost,
    put: uploadPut
  },
  fastly: {
    get: fastlyGet,
    post: fastlyPost,
    put: fastlyPut
  },
  wowza: {
    get: wowzaGet,
    post: wowzaPost,
    put: wowzaPut
  },
  accessToken
})

export default useApi
